import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>© 2024 K&K Photography</p>
    </footer>
  );
}

export default Footer;
